/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedPersonalizedFilterToast_shippingFilters$ref = any;
export type SbRespComponents_shippingFilters$ref = any;
export type SbRespComponents_shippingFilters = ReadonlyArray<{
    readonly " $fragmentRefs": SbSharedPersonalizedFilterToast_shippingFilters$ref;
    readonly " $refType": SbRespComponents_shippingFilters$ref;
}>;



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespComponents_shippingFilters",
  "type": "ShippingFilterType",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedPersonalizedFilterToast_shippingFilters",
      "args": null
    }
  ]
};
(node as any).hash = 'efe06964b9b07555da0ee972e23cecaa';
export default node;
